module.exports = __webpack_public_path__ + "img/uni.e64a6357.png";